
import * as moment from 'moment'
import SearchManager from './searchManager'
import CruiseCardsManager from './cruiseCardsManager'


const InputManager = (function(SearchManager, CruiseCardsManager) {
    // STATIC
    var MODAL;

    // PRIVATE
    var _translation;


    // ====================== CONSTRUCTOR ======================
    function InputManager() {
        // Singleton
        if (InputManager.instance) {
            throw new Error('InputManager is a singleton. Use InputManager.instance.');
        }
        // enforces new
        if (!(this instanceof InputManager)) {
            return new InputManager();
        }
    };

    // ===================== PUBLIC METHOD =====================
    InputManager.prototype.init = function() {

        // Monitor filter change (most of the filters)
        $(".search-parameter").change(_updateFilter);

        // Monitor destination change
        $(".search-parameter[name=destination]").on('change', _updateDestination);

        // Monitor reservation_type change
        $(".search-parameter[name=reservation_type]").on('change', _updateReservationType);

        // Update budget output
        $(".search-parameter[name=price]").rangeslider(
            {polyfill: false,
             onInit: function(){
                _update_range_slider_output($(this)[0].$element)
             }
            }
        ).on('input', function(e){
                _update_range_slider_output($(this))
            }
        );

        // Monitor date change
        let options = window.DATEPICKER_OPTIONS
        options.clearBtn = true
        $('.datepicker').datepicker(options).on('change', _updateDate)

        // Init clear input button
        $('button[data-toogle="clear-input"]').click(_clearInputModal);

        // Closing of modal (for mobile)
        $('.modal-more-filter').on('hide.bs.modal', _launchSearch);
        $('.modal-more-filter, .modal-search').on('show.bs.modal', function() {
            $('.modal-content.full-height, .modal-section.full-height').height(
                document.documentElement.clientHeight
            );
        });
    };

    InputManager.prototype.initSearch = function(param) {
        window.searchState = param;
    };

    InputManager.prototype.seti18nParam = function(data) {
        _translation = data;
    };

    // ===================== Event METHOD =====================

    function _updateDate(e) {
        let date = $(this).datepicker('getDate')
        if(date != null) {
          window.searchState.departure_date = moment(date).format('DD/MM/YYYY')
        } else {
          window.searchState.departure_date = ''
        }
        CruiseCardsManager.reset();
        _launchSearchIfDesktop(this);
    }

    function _updateDestination(e) {
        window.searchState.destination = $(this).val();
        _launchSearchIfDesktop(this);
    }

    function _updateFilter(e) {
        window.searchState[this.name] = this.value;
        _launchSearchIfDesktop(this);
    }

    function _clearInputModal() {
        // Clear all modal fields
        window.searchState.departure_date = ''
        window.searchState.duration = 0
        window.searchState.boat_type = 0
        window.searchState.cruise_style = 0
        window.searchState.travelers_nb = 0
        window.searchState.price = ''
        $('.modal .search-parameter.default').prop('checked', true);
        $('.datepicker').datepicker('update', '');
    }

    function _updateReservationType() {
        $(".search-parameter[name=price]").each(function(){
            _update_range_slider_output($(this))
        })
    }

    function _update_range_slider_output(input) {
        let val = input.val()
        let max_val = input.attr('max')

        let per
        if(window.searchState.reservation_type == 'private') {
            per = _translation['per_group_card_label']
        } else {
            per = _translation['per_person_card_label']
        }

        let txt
        if(val == max_val) {
          txt = _translation['all-budget']
        } else {
          txt = val + '€ max. ' + per
        }
        input.parent().find('.price-val').text(txt)
    }

    // ===================== PRIVATE METHOD =====================
    function _launchSearchIfDesktop(field) {
      var modal = $('.modal-more-filter');
      if($(field).parents('.modal-more-filter').length == 0) {
        // Field is not in a modal, so we are on desktop and we can launch search
        _launchSearch();
      }
    }

    function _launchSearch() {
        $('.background-search-loader').show();
        var end = false;

        function _end() {
            if (end)
                $('.background-search-loader').hide();
            end = true;
        }
        window.setTimeout(_end, 500);
        SearchManager.executeForFirstResults(window.searchState);
    }

    InputManager.instance = new InputManager();

    return InputManager.instance;
})(SearchManager, CruiseCardsManager);

export default InputManager



// WEBPACK FOOTER //
// ./search/static/search/js/inputManager.js